import { requestApplyUserAction } from 'api/operations/enrollmentService';
import { action, computed, makeObservable } from 'mobx';
import { createContext, useContext } from 'react';
import { UploadDocumentsModule } from 'store/modules/upload-documents/uploadDocumentsModule';
import UploadDocumentsPageStore, {
  StepInteractor,
  UploadDocumentsDomainData,
} from 'store/modules/upload-documents/uploadDocumentsPageStore';
import { UploadStep } from 'types/documentsService';
import { ChecklistCard, ChecklistCompletionStatus, USER_ACTIONS } from 'types/enrollmentService';

export default class RequiredDocumentsPageStore extends UploadDocumentsPageStore implements StepInteractor {
  public async completeStep(): Promise<void> {
    this._setIsLoading(true);
    await this._uploadDocumentsModule.submitDocuments();
    await requestApplyUserAction(this._domainData.entityId, USER_ACTIONS.COMPLETE_REQUIRED_DOCUMENTS);
  }

  public async uncompleteStep(): Promise<void> {
    this._setIsLoading(true);
    await requestApplyUserAction(this._domainData.entityId, USER_ACTIONS.UNCOMPLETE_REQUIRED_DOCUMENTS);
    await this.loadInitialData();
    this._setIsLoading(false);
  }

  public get thisStepHasBeenCompleted(): boolean {
    if (!this._enrollmentPeriodModule.checklist) {
      return false;
    }
    return (
      this._enrollmentPeriodModule.getStepCompletionStatus('DEFAULT', ChecklistCard.REQUIRED_DOCUMENTS) ===
      ChecklistCompletionStatus.COMPLETED
    );
  }

  constructor(domainData: UploadDocumentsDomainData) {
    super(domainData, UploadStep.CHECKLIST);

    this._uploadDocumentsModule = new UploadDocumentsModule({
      entityId: this._domainData.entityId,
      uploadStep: UploadStep.CHECKLIST,
    });

    makeObservable<RequiredDocumentsPageStore>(this, {
      thisStepHasBeenCompleted: computed,
      completeStep: action.bound,
      uncompleteStep: action.bound,
    });
  }
}

const RequiredDocumentsPageStoreContext = createContext(new RequiredDocumentsPageStore({ entityId: 'stub-entity' }));

export const useRequiredDocumentsPageStore = (): RequiredDocumentsPageStore => {
  return useContext(RequiredDocumentsPageStoreContext);
};

export { RequiredDocumentsPageStoreContext };
